import React from 'react';
import styled from 'styled-components';
import { array, bool, string } from 'prop-types';

const HighlightBox = styled.span`
  white-space: nowrap;
  height: 18px;
  background-color: ${({ color }) => color};
  color: #FFF;
  padding: 4px 8px;
  margin-left: 5px;
  text-transform: uppercase;
  border-radius: 8px 0px 8px 0px;
  vertical-align: middle;
  padding: ${({ big }) => (big ? '4px 8px' : '2px 8px')};
  font-size: ${({ big }) => (big ? '12px' : '10px')};
  font-weight: ${({ big }) => (big ? 'normal' : 'bold')};
`;

const VisualHighlight = ({ children, big, color }) => (
  <HighlightBox big={big} color={color}>
    {children}
  </HighlightBox>
);

VisualHighlight.propTypes = {
  children: array.isRequired,
  big: bool,
  color: string,
};

VisualHighlight.defaultProps = {
  big: false,
  color: '#6e0ad6'
};

export default VisualHighlight;
